import { LinkPresentationProps, StyledTypography } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const commonLinkStyles = css`
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    text-align: left;
    display: inline-block;
    position: relative;

    ${mediaQueriesBP.minMD} {
        font-size: 18px;
        line-height: 25px;
    }
`;

export const customLinkHoverStyles = css`
    &::after {
        content: "";
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: ${getColor(colorStrings.primaryMain)};
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }

    &:hover {
        color: ${getColor(colorStrings.primaryMain)};
        &::after {
            transform: scaleX(1);
            transform-origin: bottom left;
        }
    }
`;

export const customLinkCallToActionStyles = css`
    display: inline-flex;
    align-items: center;
    font-size: 18px;
    flex-direction: row;

    svg {
        display: none;
    }

    &::after {
        transition: background-image 0.2s;
        content: "";
        height: 13px;
        width: 15px;
        display: inline-block;
        margin-left: 7px;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M0 12.2445H2.76149L5.36873 6.37223L2.76149 0.5H0L2.60539 6.37223L0 12.2445Z" fill="%230AA7D5"/><path d="M4.38757 12.2445H7.15091L9.75629 6.37223L7.15091 0.5H4.38757L6.99481 6.37223L4.38757 12.2445Z" fill="%230AA7D5"/><path d="M8.69519 12.2445H11.4585L14.0658 6.37223L11.4585 0.5H8.69519L11.3024 6.37223L8.69519 12.2445Z" fill="%230AA7D5"/></svg>');
    }

    &:hover {
        &::after {
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M0.695068 12.2445H3.45841L6.06565 6.37223L3.45841 0.5H0.695068L3.30231 6.37223L0.695068 12.2445Z" fill="%230AA7D5"/></svg>');
        }
    }
`;

export const link: RecursivePartial<{
    defaultProps?: LinkPresentationProps | undefined;
}> = {
    defaultProps: {
        hoverStyle: {
            textDecorationStyle: "double",
        },
        css: css`
            /* Verndale Customization -- Start */
            ${commonLinkStyles}

            &.link,
            &.navigation-list-link,
            &.list-link {
                ${customLinkHoverStyles}
            }

            &.link--dark {
                color: ${getColor(colorStrings.commonGlobalWhite)};

                &&&& ${StyledTypography} {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                }

                &::after {
                    background-color: ${getColor(colorStrings.commonGlobalWhite)};
                }

                &:hover {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            }

            &.social-link {
                span {
                    color: ${getColor(colorStrings.textLink)};
                }
            }

            /* Verndale Customization -- End */
        `,
    },
};
